import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedTabs: {
        mainTabId: 'toolbar-documents-tab',
        subTabId: ''
    }
};

export const toolbarNavigationMenuSlice = createSlice({
    name: 'toolbarNavigationMenu',
    initialState: initialState,
    reducers: {
        doSetTabs: (state, action) => {
            state.selectedTabs.mainTabId = action.payload?.mainTabId;
            state.selectedTabs.subTabId = action.payload?.subTabId;
        },
    }
});

export const selectSelectedTabs = (state) => state.toolbarNavigationMenu.selectedTabs;
export const { doSetTabs } = toolbarNavigationMenuSlice.actions;
export default toolbarNavigationMenuSlice.reducer;
